import {
  getStorage,
  connectStorageEmulator,
  ref,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import { saveAs } from "file-saver";
import { app, resolveEmulatorAddress, useEmulator } from "./app";

const DEFAULT_BUCKET = "firebase-storage";
const ORG_FILES_BUCKET_BASE_NAME = "org-files-bucket";
const PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;

export { ref, getDownloadURL, uploadBytes };

export const storage = getStorage(app, `${PROJECT_ID}-${DEFAULT_BUCKET}`);

const orgFilesStorage = getStorage(
  app,
  `${PROJECT_ID}-${ORG_FILES_BUCKET_BASE_NAME}`,
);

if (useEmulator) {
  const { host, port } = resolveEmulatorAddress("storage");
  connectStorageEmulator(storage, host, port);
  connectStorageEmulator(orgFilesStorage, host, port);
}

export const downloadFromOrgFiles = async (
  storagePath: string,
  fallbackFileName: string,
) => {
  const url = await getDownloadURL(ref(orgFilesStorage, storagePath));
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
  const blob = await res.blob();
  saveAs(blob, storagePath.split("/").pop() || fallbackFileName);
};
